import type { SATTestUserAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryOrderToSQL,
} from './common'
import SATTestQ from './SATTestQ'
import SATUserQ from './SATUserQ'

const SATTestUserQ = {
  ...makeQueryModelV2<SATTestUserAttributes>('sat_test_user')([
    'id',
    'sat_test_id',
    'sat_user_id',
    'task_completions',
    'created_at',
    'deleted_at',
    'updated_at',
  ]),

  associations: (): AssociationDefinitions => ({
    SATTest: {
      query: SATTestQ,
      foreignKey: SATTestQ.id,
      sourceKey: SATTestUserQ.sat_test_id,
    },
    SATUser: {
      query: SATUserQ,
      foreignKey: SATUserQ.id,
      sourceKey: SATTestUserQ.sat_user_id,
    },
  }),

  where: (
    {
      id = null,
      satTestId = null,
      include = [],
      order = null,
    }: {
      id?: number | null | SQLFragment<number>
      satTestId?: number | null | SQLFragment<number>
      include?: IncludeAssociations
      order?: QueryOrder | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<SATTestUserAttributes> => SQL`
        FROM ${SATTestUserQ}
        ${includeAssociationsToSql(SATTestUserQ, include)}
        WHERE
            ${id != null ? SQL`${SATTestUserQ.id} = ${id} AND` : SQL``}
            ${satTestId != null ? SQL`${SATTestUserQ.sat_test_id} = ${satTestId} AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryOrderToSQL(order)}
    `,
}

export default SATTestUserQ
